export default "__VITE_ASSET__BPcm2go8__"